'use client';

import { useParams, usePathname } from 'next/navigation';

export function useLocale() {
  const params = useParams();
  const lang = params.lang as Locale;

  return lang;
}

export function useHomePageUrl() {
  const lang = useLocale();
  return lang === 'en' ? '/' : `/${lang}`;
}

export function useIsHomePage() {
  const pathname = usePathname();

  return ['/', '/en', '/it', '/fr', '/de'].includes(pathname);
}
